// 21.2.5.3 get RegExp.prototype.flags()
var $ = require('./$');
if(require('./$.descriptors') && /./g.flags != 'g')$.setDesc(RegExp.prototype, 'flags', {
  configurable: true,
  get: require('./$.flags')
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es6.regexp.flags.js
 ** module id = 265
 ** module chunks = 0
 **/